'use client'

import { Container } from '@/ui/layouts/container/Container'
import { Skin } from '@/ui/skin/Skin'
import type { PropsWithChildren } from 'react'

/**
 * Shared visual shell for pre-header banners (impersonation, punchout, etc.).
 * Renders a tinted bar above the main header with a consistent layout.
 */
export function PreHeaderBanner({ children }: PropsWithChildren) {
  return (
    <Skin tint="brand-2" className="py-2">
      <Container>
        <div className="flex items-center justify-between text-xs">{children}</div>
      </Container>
    </Skin>
  )
}
